import { all } from 'redux-saga/effects';
import fetchNews from './sagas/FetchNews';
import fetchNew from './sagas/FetchNew';

export default function* promotionsSaga() {
    yield all([
        fetchNews(),
        fetchNew()
    ])
}